import loadable from "@loadable/component";
import { PATH } from "contants/path";
import LoyaltyProgramPage from "pages/LoyaltyProgramPage";
import ReferralCode from "pages/ReferralCode";
const MessagesPage = loadable(() => import("pages/MessagesPage"));
const AccountPage = loadable(() => import("pages/AccountPage"));
const BankPage = loadable(() => import("pages/BankPage"));
const BonusHistoryPage = loadable(() => import("pages/BonusHistoryPage"));
const BonusDetail = loadable(() => import("pages/BonusPage/BonusDetail"));
const DepositPage = loadable(() => import("pages/DepositPage"));
const DocumentsPage = loadable(() => import("pages/DocumentsPage"));
const MyBonusPage = loadable(() => import("pages/MyBonusPage"));
const ProfilePage = loadable(() => import("pages/ProfilePage"));
const WithdrawPage = loadable(() => import("pages/WithdrawPage"));
const TransactionHistoryPage = loadable(
  () => import("pages/TransactionHistoryPage")
);

export const userRouter = {
  children: [
    {
      path: PATH.user.profile,
      element: <ProfilePage />,
    },
    {
      path: PATH.user.myBonus,
      element: <MyBonusPage />,
    },
    {
      path: PATH.user.deposit,
      element: <DepositPage />,
    },
    {
      path: PATH.user.cashWithdraw,
      element: <WithdrawPage />,
    },
    {
      path: PATH.user.account,
      element: <AccountPage />,
    },
    {
      path: PATH.user.bonusHistory,
      element: <BonusHistoryPage />,
    },
    {
      path: PATH.user.bonusDetail,
      element: <BonusDetail />,
    },
    {
      path: PATH.user.transactionHistory,
      element: <TransactionHistoryPage />,
    },
    {
      path: PATH.user.documents,
      element: <DocumentsPage />,
    },
    {
      path: PATH.user.messages,
      element: <MessagesPage />,
    },
    {
      path: PATH.user.bank,
      element: <BankPage />,
    },
    {
      path: PATH.user.loyaltyProgram,
      element: <LoyaltyProgramPage />,
    },
    {
      path: PATH.user.referral,
      element: <ReferralCode />,
    },
  ],
};
